module.exports = __webpack_public_path__ + "static/media/iconCanvas13.a266bc6e.svg";